import React from "react";
import { FaDice, FaTimes } from "react-icons/fa";

function Uv2DrawPanel({ selectedFiche, onDraw, onClear }) {
  return (
    <div className="mt-5 rounded-[2rem] border border-sky-200 bg-sky-50 p-4 shadow-xl shadow-sky-100/60 dark:border-sky-300/10 dark:bg-sky-500/10 dark:shadow-black/20 sm:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-sky-700 dark:text-sky-200">
            Préparation UV2
          </p>

          <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
            Tirage au sort d'une fiche
          </h2>

          <p className="mt-2 text-sm font-medium leading-6 text-slate-600 dark:text-white/60">
            Tire une fiche UV2 au hasard pour simuler une révision d'examen.
          </p>
        </div>

        <div className="grid gap-2 sm:grid-cols-2">
          <button
            type="button"
            onClick={onDraw}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-sky-600 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5"
          >
            <FaDice />
            Tirer une fiche
          </button>

          {selectedFiche !== "all" && (
            <button
              type="button"
              onClick={onClear}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
            >
              <FaTimes />
              Effacer
            </button>
          )}
        </div>
      </div>

      {selectedFiche !== "all" && (
        <div className="mt-4 rounded-[1.5rem] bg-white p-4 text-center shadow-sm dark:bg-white/10">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-slate-400">
            Fiche sélectionnée
          </p>

          <p className="mt-2 font-titre text-4xl font-bold text-sky-700 dark:text-sky-200">
            Fiche {selectedFiche}
          </p>
        </div>
      )}
    </div>
  );
}

export default Uv2DrawPanel;
